export const BACKUPS_REQUEST = 'BACKUPS_REQUEST';
export const BACKUPS_SUCCESS = 'BACKUPS_SUCCESS';
export const BACKUPS_CREATE = 'BACKUPS_CREATE';
export const BACKUPS_CREATE_JSON = 'BACKUPS_CREATE_JSON';
export const BACKUPS_REPLACE = 'BACKUPS_REPLACE';

